import { CreateToolbar, MapToolType } from "../createToolbar";
import { ToolbarButtonId, getToolbarId } from "./toolbarEnum";

export class ToolbarClippingPlaneHandler {
    constructor(private toolbar: CreateToolbar) { }
    
    private isInteractionPaused = false;
    private activeAxisButtonId: string | null = null;

    handle = (idElement: string, containerId: string) => {
        const listBtnToggle = [
            getToolbarId(ToolbarButtonId.CLIPPING_PLANE, containerId),
            getToolbarId(ToolbarButtonId.CLIPPING_PLANE_Z, containerId),
            getToolbarId(ToolbarButtonId.CLIPPING_PLANE_X, containerId),
            getToolbarId(ToolbarButtonId.CLIPPING_PLANE_Y, containerId),
            getToolbarId(ToolbarButtonId.CLIPPING_PLANE_TOGGLE_GIZMO, containerId),
            getToolbarId(ToolbarButtonId.CLIPPING_PLANE_LOCK_GIZMO, containerId),
            getToolbarId(ToolbarButtonId.CLIPPING_PLANE_DELETE, containerId),
            getToolbarId(ToolbarButtonId.CLIPPING_PLANE_DONE, containerId)
        ];

        const listIdGroup = [
            getToolbarId(ToolbarButtonId.GROUP_CAMERA, containerId),
            getToolbarId(ToolbarButtonId.FLY_CAMERA, containerId),
            getToolbarId(ToolbarButtonId.ELEVATION_PROFILE, containerId)
        ];

        const axisButtons = [
            getToolbarId(ToolbarButtonId.CLIPPING_PLANE_Z, containerId),
            getToolbarId(ToolbarButtonId.CLIPPING_PLANE_X, containerId),
            getToolbarId(ToolbarButtonId.CLIPPING_PLANE_Y, containerId)
        ];

        if (idElement === getToolbarId(ToolbarButtonId.CLIPPING_PLANE, containerId)) {
            const pointDoneBtn = document.getElementById(`done-point-${containerId}`);
            if (pointDoneBtn && pointDoneBtn.style.display !== 'none') {
                this.toolbar.ToolBarActionPoint(`done-point-${containerId}`, containerId);
            }
            this.isInteractionPaused = false;
            this.activeAxisButtonId = getToolbarId(ToolbarButtonId.CLIPPING_PLANE_Z, containerId);
            this.toolbar._activeBtnClippingPlane = true;
            this.toolbar._activeBtn(getToolbarId(ToolbarButtonId.CLIPPING_PLANE, containerId), true);
            this.toolbar._activeBtn(getToolbarId(ToolbarButtonId.CLIPPING_PLANE_LOCK_GIZMO, containerId), false);

            this.toolbar.deactivateOtherTools(MapToolType.CLIPPING_PLANE);

            // Hide other groups and show clipping plane submenu buttons
            this.toolbar._showHideElementsByID(listIdGroup, false);
            this.toolbar._showHideElementsByID(listBtnToggle, true);
            this.toolbar._showHideElementByID(getToolbarId(ToolbarButtonId.CLIPPING_PLANE, containerId), false);

            // Register callback for double-clicking to place new position: resets toolbar to Z
            this.toolbar._clippingPlane!.onPositionPlaced = () => {
                this.activeAxisButtonId = getToolbarId(ToolbarButtonId.CLIPPING_PLANE_Z, containerId);
                this.toolbar._activeBtnInGroup(axisButtons, this.activeAxisButtonId);
            };

            // Gizmo is visible by default when tool activates
            this.toolbar._activeBtn(getToolbarId(ToolbarButtonId.CLIPPING_PLANE_TOGGLE_GIZMO, containerId), true);

            this.toolbar._contextMenu?.destroyContextMenu();
            this.toolbar._clippingPlane!.createClipping();

            this.activeAxisButtonId = getToolbarId(ToolbarButtonId.CLIPPING_PLANE_Z, containerId);
            this.toolbar._activeBtnInGroup(axisButtons, this.activeAxisButtonId);
            this.toolbar._clippingPlane!.setMode("up");
        }
        else if (idElement === getToolbarId(ToolbarButtonId.CLIPPING_PLANE_Z, containerId)) {
            if (this.isInteractionPaused) {
                this.isInteractionPaused = false;
                this.toolbar._clippingPlane!.setInteractionPaused(false);
                this.toolbar._contextMenu?.destroyContextMenu();
                this.toolbar._activeBtn(getToolbarId(ToolbarButtonId.CLIPPING_PLANE_LOCK_GIZMO, containerId), false);
            }
            this.activeAxisButtonId = idElement;
            this.toolbar._activeBtnInGroup(axisButtons, idElement);
            this.toolbar._clippingPlane!.setMode("up");
        }
        else if (idElement === getToolbarId(ToolbarButtonId.CLIPPING_PLANE_X, containerId)) {
            if (this.isInteractionPaused) {
                this.isInteractionPaused = false;
                this.toolbar._clippingPlane!.setInteractionPaused(false);
                this.toolbar._contextMenu?.destroyContextMenu();
                this.toolbar._activeBtn(getToolbarId(ToolbarButtonId.CLIPPING_PLANE_LOCK_GIZMO, containerId), false);
            }
            this.activeAxisButtonId = idElement;
            this.toolbar._activeBtnInGroup(axisButtons, idElement);
            this.toolbar._clippingPlane!.setMode("east");
        }
        else if (idElement === getToolbarId(ToolbarButtonId.CLIPPING_PLANE_Y, containerId)) {
            if (this.isInteractionPaused) {
                this.isInteractionPaused = false;
                this.toolbar._clippingPlane!.setInteractionPaused(false);
                this.toolbar._contextMenu?.destroyContextMenu();
                this.toolbar._activeBtn(getToolbarId(ToolbarButtonId.CLIPPING_PLANE_LOCK_GIZMO, containerId), false);
            }
            this.activeAxisButtonId = idElement;
            this.toolbar._activeBtnInGroup(axisButtons, idElement);
            this.toolbar._clippingPlane!.setMode("north");
        }
        else if (idElement === getToolbarId(ToolbarButtonId.CLIPPING_PLANE_TOGGLE_GIZMO, containerId)) {
            const isVisible = this.toolbar._clippingPlane!.getGizmoVisibility();
            this.toolbar._clippingPlane!.showHideGizmo(!isVisible);
            this.toolbar._activeBtn(getToolbarId(ToolbarButtonId.CLIPPING_PLANE_TOGGLE_GIZMO, containerId), !isVisible);
        }
        else if (idElement === getToolbarId(ToolbarButtonId.CLIPPING_PLANE_LOCK_GIZMO, containerId)) {
            this.isInteractionPaused = !this.isInteractionPaused;

            // Make lock button visually active and deactivate other submenu buttons
            if (this.isInteractionPaused) {
                // Deactivate all submenu buttons then activate only lock button,
                // but preserve the gizmo-visibility toggle state so the "eye" doesn't flip.
                const gizmoVisible = this.toolbar._clippingPlane!.getGizmoVisibility();
                this.toolbar._unActiveBtnInGroup(listBtnToggle);
                // Restore gizmo toggle button to reflect actual visibility
                this.toolbar._activeBtn(getToolbarId(ToolbarButtonId.CLIPPING_PLANE_TOGGLE_GIZMO, containerId), gizmoVisible);
                this.toolbar._activeBtn(getToolbarId(ToolbarButtonId.CLIPPING_PLANE_LOCK_GIZMO, containerId), true);

                // Pause gizmo interactions in the ClippingPlane and re-enable context menu
                this.toolbar._clippingPlane!.setInteractionPaused(true);
                this.toolbar._contextMenu?.createContextMenu();
            } else {
                // Unlock: restore main clipping button active state and allow interactions
                this.toolbar._activeBtn(getToolbarId(ToolbarButtonId.CLIPPING_PLANE_LOCK_GIZMO, containerId), false);
                this.toolbar._activeBtn(getToolbarId(ToolbarButtonId.CLIPPING_PLANE, containerId), true);
                this.toolbar._activeBtnInGroup(axisButtons, this.activeAxisButtonId || getToolbarId(ToolbarButtonId.CLIPPING_PLANE_Z, containerId));
                this.toolbar._clippingPlane!.setInteractionPaused(false);
                // When unlocking, remove context menu so clipping handlers receive events
                this.toolbar._contextMenu?.destroyContextMenu();
                // Ensure gizmo toggle reflects current visibility after unlocking
                const gizmoVisible = this.toolbar._clippingPlane!.getGizmoVisibility();
                this.toolbar._activeBtn(getToolbarId(ToolbarButtonId.CLIPPING_PLANE_TOGGLE_GIZMO, containerId), gizmoVisible);
            }
        }
        else if (idElement === getToolbarId(ToolbarButtonId.CLIPPING_PLANE_DELETE, containerId)) {
            this.toolbar._clippingPlane!.resetClipping();
        }
        else if (idElement === getToolbarId(ToolbarButtonId.CLIPPING_PLANE_DONE, containerId)) {
            this.isInteractionPaused = false;
            this.toolbar._clippingPlane!.setInteractionPaused(false);
            this.toolbar._activeBtnClippingPlane = false;
            this.toolbar._clippingPlane!.deactivate();

            // Hide submenu buttons and show main toolbar back
            this.toolbar._showHideElementsByID(listBtnToggle, false);
            
            // If measure tool is active, don't show the mutually hidden elements
            const measureDoneBtn = document.getElementById(`done-dim-${containerId}`);
            const isMeasureActive = measureDoneBtn && measureDoneBtn.style.display !== 'none';
            
            if (isMeasureActive) {
                const filteredList = listIdGroup.filter(id => ![
                    getToolbarId(ToolbarButtonId.GROUP_DATA, containerId),
                    getToolbarId(ToolbarButtonId.DATA_ELEMENT, containerId),
                    getToolbarId(ToolbarButtonId.GROUP_CAMERA, containerId),
                    getToolbarId(ToolbarButtonId.FLY_CAMERA, containerId)
                ].includes(id));
                this.toolbar._showHideElementsByID(filteredList, true);
            } else {
                this.toolbar._showHideElementsByID(listIdGroup, true);
            }
            
            this.toolbar._showHideElementByID(getToolbarId(ToolbarButtonId.CLIPPING_PLANE, containerId), true);

            // Reset all button active states in submenu
            this.toolbar._unActiveBtnInGroup(listBtnToggle);

            if (!isMeasureActive) {
                this.toolbar._contextMenu?.createContextMenu();
            }
        }
    };
}
